
import message from "./modules/views/message";
import building from "./modules/views/building";
import systemlog from "./modules/views/systemlog";
import users from "./modules/views/users";
import revenue from "./modules/views/revenue";
import expense from "./modules/views/expense";
import bill from "./modules/views/bill";
import employee from "./modules/views/employee";

const modules: { [key: string]: any } = {
  building,
  users,
  employee,
  message,
  revenue,
  expense,
  bill,
  systemlog
};

export default modules;
